var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container apply-box" }, [
    _c(
      "div",
      { staticClass: "common-header" },
      [
        _c("common-header", {
          attrs: {
            headerList: [
              { label: "系统管理", url: "" },
              { label: "权限申请", url: "" }
            ]
          }
        })
      ],
      1
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "apply-table" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.showLoading,
                expression: "showLoading"
              }
            ],
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              "element-loading-custom-class": "loadingSize",
              "element-loading-background": "rgba(0, 0, 0, 0.2)",
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
              height: _vm.tableHeight,
              "tooltip-effect": "dark"
            }
          },
          [
            _c("template", { slot: "empty" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center"
                  }
                },
                [_c("no-data", { attrs: { height: "400px", width: "400px" } })],
                1
              )
            ]),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "systemName",
                  width: "250",
                  "min-width": "80",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.systemName)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.systemName))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              },
              [
                _c("template", { slot: "header" }, [
                  _c("span", { staticClass: "header-ellipsis font14" }, [
                    _vm._v("系统名称")
                  ])
                ])
              ],
              2
            ),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "roleName",
                  width: "250",
                  "min-width": "80",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.roleName)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.roleName))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              },
              [
                _c("template", { slot: "header" }, [
                  _c("span", { staticClass: "header-ellipsis font14" }, [
                    _vm._v("角色名称")
                  ])
                ])
              ],
              2
            ),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "roleDescription",
                  "min-width": "80",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.roleDescription)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.roleDescription))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              },
              [
                _c("template", { slot: "header" }, [
                  _c("span", { staticClass: "header-ellipsis font14" }, [
                    _vm._v("角色说明")
                  ])
                ])
              ],
              2
            ),
            _c("el-table-column", {
              attrs: { label: "操作", fixed: "right", width: "80" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "op-edit",
                          staticStyle: {
                            cursor: "pointer",
                            color: "var(--mainColor)"
                          },
                          on: {
                            click: function($event) {
                              return _vm.apply(scope)
                            }
                          }
                        },
                        [_vm._v(" 申请 ")]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          2
        )
      ],
      1
    ),
    _c("div", { staticClass: "footer-page" }, [
      _c(
        "div",
        { staticClass: "apply-footer-right" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              "current-page": _vm.pageNum,
              "page-sizes": [10, 20, 50, 100, 1000, 2000],
              "hide-on-single-page": false
            },
            on: {
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              },
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "apply-top" }, [
      _c("div", [
        _c("div", { staticClass: "common-title" }, [_vm._v("子系统权限申请")]),
        _c("div", { staticClass: "desc" }, [
          _vm._v(
            " 门户目前对部分功能提供自主申请服务，主要包括在内部检查、监管评价、员工行为管理等模块中的查询权限申请，用户可通过提交申请审批流，待审批通过后则会获得对应权限。 "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }